import { any, bool, func } from 'prop-types'
import { Size } from '@opallabs/gem'
import { kuiperClassNames, Conditional, Loader } from '@opallabs/kuiper'
import {
  Tooltip,
  Button,
  Icon,
  APPROVAL_GLYPH,
  TASK_GLYPH,
} from '@opallabs/lapidary'
import { testFeature } from '@opallabs/principles'

import './styles.scss'

function getBlurbText(disabled) {
  if (disabled) {
    return 'No workflow phases have been added yet.'
  }
  return 'Select a phase type'
}

const renderApprovalButton = (
  shouldDisableApprovalPhaseButton,
  onSetAsApprovalPhase
) => {
  if (shouldDisableApprovalPhaseButton) {
    return (
      <Tooltip
        theme="light"
        text="This content has already passed final approval"
        type="description"
        size="small"
      >
        <Button
          aria-disabled={true}
          buttonText="Approval Phase"
          variant="tertiary"
          icon={
            <Icon
              ariaHidden
              glyph={APPROVAL_GLYPH}
              height={Size.Icon}
              width={Size.Icon}
            />
          }
          iconPosition="leading"
          name="approval-phase"
          styleOverrides={{
            // Actually disabling this button will prevent the
            // tooltip from showing, so we'll visually disable it
            button: {
              opacity: 0.5,
            },
          }}
        />
      </Tooltip>
    )
  }
  return (
    <Button
      buttonText="Approval Phase"
      variant="tertiary"
      icon={
        <Icon
          ariaHidden
          glyph={APPROVAL_GLYPH}
          height={Size.Icon}
          width={Size.Icon}
        />
      }
      iconPosition="leading"
      name="approval-phase"
      onClick={onSetAsApprovalPhase}
    />
  )
}

const PhasePlaceholder = ({
  className,
  disablePhaseCreation,
  loading,
  onCancel,
  onSetAsApprovalPhase,
  onSetAsTaskPhase,
  shouldDisableApprovalPhaseButton,
  shouldRenderCancelButton,
}) => (
  <div className={kuiperClassNames('phasePlaceholder', 'n10', className)}>
    <Conditional condition={shouldRenderCancelButton}>
      <Button
        ariaLabel="cancel"
        className={kuiperClassNames('close')}
        icon={
          <Icon
            ariaHidden
            glyph="gem-close"
            height={Size.Icon}
            width={Size.Icon}
          />
        }
        onClick={onCancel}
        variant="ghost"
      />
    </Conditional>

    <p
      className={kuiperClassNames('blurb', {
        'blurb--disabled': disablePhaseCreation,
      })}
    >
      {getBlurbText(disablePhaseCreation)}
    </p>

    <Conditional condition={!disablePhaseCreation}>
      <div className={kuiperClassNames('options', 'n10', 'hasBgColor')}>
        <Tooltip
          disabled={testFeature('workflow')}
          theme="light"
          text="Your Opal does not support task phases"
          type="description"
          size="small"
        >
          <div>
            <Button
              aria-disabled={!testFeature('workflow')}
              icon={
                <Icon
                  ariaHidden
                  glyph={TASK_GLYPH}
                  height={Size.Icon}
                  useHypernova={true}
                  width={Size.Icon}
                />
              }
              iconPosition="leading"
              buttonText="Task Phase"
              name="task-phase"
              onClick={testFeature('workflow') ? onSetAsTaskPhase : undefined}
              variant="tertiary"
              styleOverrides={
                !testFeature('workflow') ? { opacity: 0.5 } : undefined
              }
            />
          </div>
        </Tooltip>
        {renderApprovalButton(
          shouldDisableApprovalPhaseButton,
          onSetAsApprovalPhase
        )}
      </div>
    </Conditional>

    <Loader loaded={!loading} theme="n9" />
  </div>
)

PhasePlaceholder.propTypes = {
  className: any,
  disablePhaseCreation: bool,
  loading: bool,
  onCancel: func,
  onSetAsApprovalPhase: func,
  onSetAsTaskPhase: func,
  shouldDisableApprovalPhaseButton: bool,
  shouldRenderCancelButton: bool,
}

export default PhasePlaceholder
